import { ACTIONS } from './action.js';

export default function reducer(state, action) {

  switch (action.type) {

      case ACTIONS.FETCH:
        return action.payload;

      case ACTIONS.CREATE:
        return [...state, action.payload];

      case ACTIONS.EDIT:
        return state.map(question => {
          if (question.QUESTION_ID === action.payload.QUESTION_ID) {
            return { ...question, ...action.payload }
          }

          return question;
        });

      case ACTIONS.DELETE:
        return state.filter(item => item.ANSWER_ACTION_ID !== action.payload);

      default:
        return state;
  }
}